module.exports = "https://la-static.vkplay.ru/promo/newstart/img/striker.638a4184.png";